import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/bootstrap');

export const boostrapApp = actionCreator.async<any, any>('BOOTSTRAP_STARTED');
